<template>
  <div class="sl-studio-container">
    <router-view />
  </div>
</template>

<script lang="ts">
import Component from 'vue-class-component';
import Base from './components/Base';

@Component({})
export default class Overlay extends Base {}
</script>

<style scoped lang="less">
.sl-studio-container {
  height: 100%;
}
</style>
